'use client';

import { useEffect, useState } from 'react';
import Messenger from '@/utils/Messenger';

export default function useWebView() {
  const [isSupport, setIsSupport] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsSupport(Messenger.isSupport);
      setIsLoading(false);
    }
  }, []);

  return {
    isSupport,
    isLoading,
  };
}